import React, { Component } from 'react'

import classes from './PositionActions.scss'

import Menu from '@material-ui/core/Menu'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import CloseIcon from '@material-ui/icons/Close'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import { withTranslate } from 'react-redux-multilingual'
class PositionActions extends Component {
  state = {
    target: null
  }

  triggerContent = e => {
    e.persist()
    this.setState({
      target: e.target
    })
  }
  actionToClicked = () => {
    this.props.actionToClicked()
    this.hideContent()
  }
  delegateClicked = () => {
    this.props.delegateClicked()
    this.hideContent()
  }
  deleteClicked = () => {
    this.props.deleteClicked()
    this.hideContent()
  }

  hideContent = () => {
    this.setState({
      target: null
    })
  }

  render() {
    return (
      <div>
        <IconButton onClick={this.triggerContent}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={this.state.target}
          open={!!this.state.target}
          onClose={this.hideContent}
          keepMounted>
          <MenuItem className={classes.Button} onClick={this.actionToClicked}>
            {this.props.translate('action_To')}
          </MenuItem>
          <MenuItem className={classes.Button} onClick={this.delegateClicked}>
            {this.props.translate('delegate')}
          </MenuItem>
          <MenuItem className={classes.Button} onClick={this.deleteClicked}>
            <CloseIcon />
          </MenuItem>
        </Menu>
      </div>
    )
  }
}

export default withTranslate(PositionActions)
